/**
 * Fichier de réexportation pour préserver la rétrocompatibilité des imports dans l'application.
 * InsRealservice est un alias du contrat InsServiceAbstract : c'est le jeton fourni par la factory (ins-service.factory.ts),
 * qui choisit la stratégie (websocket ou API REST) à l'exécution. Les types de la stratégie websocket restent réexportés.
 */

export * from './strategies/ins-websocket.strategy';

export { InsServiceAbstract as InsRealservice } from './ins-service.abstract';
